import { useMutation } from 'react-query'
import request from '../request'

export const useCreateUpload = () => {
  return useMutation(
    ({
      file,
      mapped_columns,
      upload_data,
    }: {
      upload_data: Record<string, string | number>
      file: File
      mapped_columns: any
    }) => {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('mapped_columns', JSON.stringify(mapped_columns))
      formData.append(
        'upload_data',
        JSON.stringify({
          ...upload_data,
        }),
      )
      return request({
        url: `/uploads`,
        method: 'POST',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },
  )
}
